<template>
  <v-container class="futuristic-container">
    <v-tabs
      v-model="active"
      slider-color="#587e27"
    >
      <v-tab key="visitor_types" ripple>Visitor Types</v-tab>
      <v-tab key="identification_types" ripple>Identification Types</v-tab>
      <v-tab-item key="visitor_types">
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ADD VISITOR TYPE</h4>
                  <div class="title-decoration"></div>
                </v-card-title>
                <v-container>
                  <v-form ref="visitorForm" v-model="visitorFormValid" @submit.prevent="postVisitorType()">
                    <v-text-field
                      label="Name"
                      v-model="type.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                    <v-textarea
                      label="Description"
                      v-model="type.description"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-textarea>
                    <v-btn
                      depressed
                      block
                      color="#587e27"
                      type="submit"
                      class="futuristic-btn"
                      v-if="update === false"
                    >
                      Add
                    </v-btn>
                    <v-btn
                      depressed
                      block
                      color="#f9a825"
                      type="submit"
                      class="futuristic-btn"
                      v-if="update === true"
                    >
                      Update
                    </v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg8 md8 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-container>
                  <table class="futuristic-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(type, index) in AllVisitorTypes" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ type.visitor_type_name }}</td>
                        <td>{{ type.visitor_type_description }}</td>
                        <td>
                          <v-btn
                            depressed
                            color="#e84118"
                            small
                            class="futuristic-btn"
                            v-if="index > 4 && update === false"
                            @click="deleteVisitorType(type.visitor_type_public_id)"
                          >
                            Remove
                          </v-btn>
                          <v-btn
                            depressed
                            color="#f9a825"
                            small
                            class="futuristic-btn"
                            v-if="update === false"
                            @click="updateVisitorType(index)"
                          >
                            Update
                          </v-btn>
                          <v-btn
                            depressed
                            color="#e84118"
                            small
                            class="futuristic-btn"
                            v-if="update === true"
                            @click="CancelUpdateVisitorType(index)"
                          >
                            Cancel
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item key="identification_types">
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ADD IDENTIFICATION TYPE</h4>
                  <div class="title-decoration"></div>
                </v-card-title>
                <v-container>
                  <v-form ref="identificationForm" v-model="identificationFormValid" @submit.prevent="postIdentificationType()">
                    <v-text-field
                      label="Name"
                      v-model="identification.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                    <v-textarea
                      label="Description"
                      v-model="identification.description"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-textarea>
                    <v-btn
                      depressed
                      block
                      color="#587e27"
                      type="submit"
                      class="futuristic-btn"
                      v-if="update2 === false"
                    >
                      Add
                    </v-btn>
                    <v-btn
                      depressed
                      block
                      color="#f9a825"
                      type="submit"
                      class="futuristic-btn"
                      v-if="update2 === true"
                    >
                      Update
                    </v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg8 md8 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-container>
                  <table class="futuristic-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(type, index) in AllIdentificationTypes" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ type.identification_type_name }}</td>
                        <td>{{ type.identification_type_description }}</td>
                        <td>
                          <v-btn
                            depressed
                            color="#e84118"
                            small
                            class="futuristic-btn"
                            v-if="index > 3 && update2 === false"
                            @click="deleteIdentificationType(type.identification_type_public_id)"
                          >
                            Remove
                          </v-btn>
                          <v-btn
                            depressed
                            color="#f9a825"
                            small
                            class="futuristic-btn"
                            v-if="update2 === false"
                            @click="updateIdentificationType(index)"
                          >
                            Update
                          </v-btn>
                          <v-btn
                            depressed
                            color="#e84118"
                            small
                            class="futuristic-btn"
                            v-if="update2 === true"
                            @click="CancelUpdateIdentificationType(index)"
                          >
                            Cancel
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active: '',
      visitorFormValid: true,
      identificationFormValid: true,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      update: false,
      update2: false,
      type: {
        name: '',
        description: '',
        type_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      identification: {
        name: '',
        description: '',
        type_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_visitor_types')
    this.$store.dispatch('get_all_identification_types')
  },
  methods: {
    postIdentificationType: function () {
      if (this.$refs.identificationForm.validate()) {
        var instance = this
        if (this.update2 === false) {
          this.$store.dispatch('post_identification_type', this.identification).then(function () {
            instance.identification.name = ''
            instance.identification.description = ''
          })
        } else {
          this.$store.dispatch('update_identification_type', this.identification).then(function () {
            instance.update2 = false
            instance.identification.name = ''
            instance.identification.description = ''
            instance.identification.type_id = ''
          })
        }
      }
    },
    deleteIdentificationType: function (publicId) {
      var data = {
        session_id: localStorage.getItem('lkjhgfdsa'),
        type_id: publicId
      }
      this.$store.dispatch('delete_identification_type', data)
    },
    updateIdentificationType: function (index) {
      var type = this.AllIdentificationTypes[index]
      this.identification.name = type.identification_type_name
      this.identification.description = type.identification_type_description
      this.identification.type_id = type.identification_type_public_id
      this.update2 = true
    },
    CancelUpdateIdentificationType: function () {
      this.update2 = false
      this.identification.name = ''
      this.identification.description = ''
      this.identification.type_id = ''
    },
    postVisitorType: function () {
      if (this.$refs.visitorForm.validate()) {
        var instance = this
        if (this.update === false) {
          this.$store.dispatch('post_visitor_type', this.type).then(function () {
            instance.type.name = ''
            instance.type.description = ''
          })
        } else {
          this.$store.dispatch('update_visitor_type', this.type).then(function () {
            instance.update = false
            instance.type.name = ''
            instance.type.description = ''
            instance.type.type_id = ''
          })
        }
      }
    },
    deleteVisitorType: function (publicId) {
      var data = {
        session_id: localStorage.getItem('lkjhgfdsa'),
        type_id: publicId
      }
      this.$store.dispatch('delete_visitor_type', data)
    },
    updateVisitorType: function (index) {
      var type = this.AllVisitorTypes[index]
      this.type.name = type.visitor_type_name
      this.type.description = type.visitor_type_description
      this.type.type_id = type.visitor_type_public_id
      this.update = true
    },
    CancelUpdateVisitorType: function () {
      this.update = false
      this.type.name = ''
      this.type.description = ''
      this.type.type_id = ''
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.futuristic-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.futuristic-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.futuristic-table th,
.futuristic-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
}

.futuristic-table tr:hover {
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }

  .futuristic-table th,
  .futuristic-table td {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table th,
  .futuristic-table td {
    padding: 6px;
    font-size: 0.85rem;
  }
}
</style>
